export default __webpack_public_path__ + "static/media/mongodb-logo.c20e1bc7.png";